import type { ProposalPlantProduct, WorkOrderTransferTruck } from "generated/graphql";

export function getProposalPlantRows(materials: readonly ProposalPlantProduct[]) {
  return materials.map((material) => ({
    id: material.id,
    proposalPlantProductId: material.id,
    plant: material.plant,
    plantProduct: { id: material.plantProductId, type: material.type },
    name: material.plant?.name,
    type: material.type,
    materialNeeded: material.materialNeededOverride ?? material.materialNeeded,
  }));
}

type PlantMaterialRow = {
  proposalPlantProductId?: string | null;
  plant?: { id?: string | null } | null;
  plantProduct?: { id?: string | null } | null;
};

export function getWorkOrderPlantTrucks(
  plant: PlantMaterialRow,
  plants: readonly PlantMaterialRow[],
  trucks: readonly WorkOrderTransferTruck[]
): WorkOrderTransferTruck[] {
  if (plant.proposalPlantProductId) {
    return trucks.filter((truck) => truck.proposalPlantProductId === plant.proposalPlantProductId);
  }

  // Legacy rows have no proposal-material link. Only use an unambiguous catalog match.
  if (!plant.plant?.id || !plant.plantProduct?.id) return [];
  const sameMaterials = plants.filter(
    (other) =>
      other.plant?.id === plant.plant.id && other.plantProduct?.id === plant.plantProduct.id
  );
  if (sameMaterials.length !== 1) return [];

  const matches = trucks.filter(
    (truck) =>
      truck.proposalPlantProduct?.plantProductId === plant.plantProduct.id &&
      truck.proposalPlantProduct?.plant?.plantId === plant.plant.id
  );
  const proposalMaterialIds = new Set(
    matches.map((truck) => truck.proposalPlantProductId ?? truck.proposalPlantProduct?.id)
  );
  return proposalMaterialIds.size <= 1 ? matches : [];
}
